const CHARS = 'AĄBCĆDEĘFGHIJKLŁMNŃOÓPQRSŚTUVWXYZŹŻ0123456789!@#$%&';

function randomChar() {
  return CHARS[Math.floor(Math.random() * CHARS.length)];
}

function shuffle(n) {
  const arr = Array.from({ length: n }, (_, i) => i);
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

function transition(el, from, to, onDone) {
  const toLen = to.length;
  const fromLen = from.length;
  const maxLen = Math.max(fromLen, toLen);
  const fromChars = [...from];
  const toChars = [...to];

  const scrambling = new Array(maxLen).fill(false);
  const settled = new Array(maxLen).fill(false);
  // Nadmiarowe znaki (gdy from dłuższy od to) - oznaczamy jako "do usunięcia"
  const removed = new Array(maxLen).fill(false);

  const dissolveOrder = shuffle(maxLen);
  const settleOrder = shuffle(toLen);
  // Kolejność usuwania nadmiarowych znaków
  const extraIndices = [];
  for (let i = toLen; i < maxLen; i++) extraIndices.push(i);
  const removeOrder = shuffle(extraIndices.length).map(i => extraIndices[i]);

  let dissolvedCount = 0;
  let settledCount = 0;
  let removedCount = 0;
  let step = 0;

  const interval = setInterval(() => {
    step++;

    if (dissolvedCount < maxLen && step % 2 === 0) {
      scrambling[dissolveOrder[dissolvedCount]] = true;
      dissolvedCount++;
      if (dissolvedCount < maxLen && Math.random() > 0.4) {
        scrambling[dissolveOrder[dissolvedCount]] = true;
        dissolvedCount++;
      }
    }

    if (dissolvedCount > Math.floor(maxLen * 0.4) && step % 2 === 0) {
      // Ustalaj znaki docelowe
      if (settledCount < toLen) {
        settled[settleOrder[settledCount]] = true;
        settledCount++;
        if (settledCount < toLen && Math.random() > 0.4) {
          settled[settleOrder[settledCount]] = true;
          settledCount++;
        }
      }
      // Usuwaj nadmiarowe znaki
      if (removedCount < removeOrder.length) {
        removed[removeOrder[removedCount]] = true;
        removedCount++;
      }
    }

    const output = [];
    for (let i = 0; i < maxLen; i++) {
      if (removed[i]) continue;
      if (i < toLen && settled[i]) {
        output.push(toChars[i]);
      } else if (scrambling[i]) {
        output.push(randomChar());
      } else if (i < fromLen) {
        output.push(fromChars[i]);
      } else {
        output.push(randomChar());
      }
    }

    el.textContent = output.join('');

    if (settledCount >= toLen && removedCount >= removeOrder.length) {
      clearInterval(interval);
      el.textContent = to;
      if (onDone) onDone();
    }
  }, 50);
}

function initScramble(el) {
  const words = JSON.parse(el.dataset.words);
  let index = 0;

  function next() {
    const from = el.textContent || '';
    const to = words[index];
    index = (index + 1) % words.length;

    transition(el, from, to, () => {
      setTimeout(next, 3000);
    });
  }

  next();
}

document.querySelectorAll('.scramble').forEach(initScramble);
